module.exports = __webpack_public_path__ + "static/media/eyeIcon.7e7f37c3.svg";